


<main id="content" role="main" class="main">

    <div class="content container">
        <div >
            <nav aria-label="breadcrumb">
                <ol id="w0" class="breadcrumb">
                    <li class="breadcrumb-item"><a routerLink="/">{{'home'|translate}}</a></li>
                    <li class="breadcrumb-item"><a routerLink="/Sections" [queryParams]="{SectionId:SectionIdEnv}">{{'e-service'|translate}}</a></li>
                    <li class="breadcrumb-item active" aria-current="page">
                        {{sectionName}}
                    </li>
                </ol>
            </nav>
        </div>
        <div class="row row-cols-md-4 mb-10" >
            <div class="col mb-3 mb-lg-5" *ngFor="let item of services">

                <div >
                    <div class="card card-hover-shadow text-center h-100">

                        <div class="card-progress-wrap">
                            <div class="progress card-progress">
                                <div class="progress-bar {{colorArr[index]}}" role="progressbar" style="width: 100%"
                                    aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>


                        <div class="card-body">
                            <div class="row align-items-center text-start mb-4">
                                <div class="col">
                                    <span class="badge bg-soft-danger text-danger p-2"></span>
                                </div>
                            </div>
                            <div class="d-flex justify-content-center mb-2">

                                <img class="avatar avatar-lg" [src]="imagesArr[index]" alt="Image Description">
                            </div>
                            <div class="mb-2 {{textColorArr[index]}}">
                                <h4 class="mx-2">{{item.name}}</h4>
                            </div>
                        </div>

                        <div class="card-footer">

                            <a type="button" class="btn btn-outline-dark"  role="button" (click)="apply(item)"  >
                                {{'applyForm'|translate}}
                            </a>
                        </div>
                    </div>
                </div>

            </div>

            <ng-container *ngIf="services2.length>0">
            
                <div class="col mb-3 mb-lg-5" *ngFor="let item of services2">

                    <div >
                        <div class="card card-hover-shadow text-center h-100">
    
                            <div class="card-progress-wrap">
                                <div class="progress card-progress">
                                    <div class="progress-bar {{colorArr[index]}}" role="progressbar" style="width: 100%"
                                        aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
    
    
                            <div class="card-body">
                                <div class="row align-items-center text-start mb-4">
                                    <div class="col">
                                        <span class="badge bg-soft-danger text-danger p-2"></span>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-center mb-2">
    
                                    <img class="avatar avatar-lg" [src]="imagesArr[index]" alt="Image Description">
                                </div>
                                <div class="mb-2 {{textColorArr[index]}}">
                                    <h4 class="mb-1">{{item.title}}</h4>
                                </div>
                            </div>
    
                            <div class="card-footer">
    
                                <a type="button" class="btn btn-outline-dark"  role="button" (click)="openForm(item.id)"  >{{'applyForm'|translate}} </a>
                            </div>
                        </div>
                    </div>
    
                </div>

            </ng-container>

     


        </div>
    </div>


      <!-- <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">{{serviceCard?.title}}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                
              <p [innerHTML]="serviceCard?.description"></p>
            </div>
            <div class="modal-footer" style="margin-right: auto;">
                <button (click)="goToForm(selectedServiceId)" class="btn btn-primary">تقديم الطلب</button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">اغلاق</button>
            </div>
          </div>
        </div>
      </div> -->

</main>